import React, { useEffect, useState } from "react";
import apiDinner from "../../../apis/dinner/apiDinner";
import apiProduct from "../../../apis/product/apiProduct";
import AppAlert from "../../common/AppAlert";
import AppLoading from "../../common/AppLoading";
import BreadCrumb from "../../common/AppBreadCrumb";
import AppInput from "../../controls/AppInput";
import AppSelect from "../../controls/AppSelect";
import AppTitle from "../../controls/AppTitle";

function ProductCreateScreen() {
	const [name, setName] = useState("");
	const [price, setPrice] = useState("");
	const [dinner, setDinner] = useState({});
	const [loading, setLoading] = useState(false);
	const [dinnerList, setDinnerList] = useState([]);
	const [errorsForm, setErrorsForm] = useState({});

	const CreateProduct = async () => {
		const product = {
			name: name,
			price: price,
			dinner_id: dinner.value,
		};

		setLoading(true);
		const response = await apiProduct.createProduct(product);
		console.log(response);
		setLoading(false);

		if (response.ok) {
			AppAlert.SimpleAlert(response.message);
			setErrorsForm({});
		} else {
			setErrorsForm(response);
		}
	};

	const GetDinners = async () => {
		const response = await apiDinner.getDinnersDropdown();

		if (response.ok) {
			setDinnerList(response.data);
		}
	};

	useEffect(() => {
		GetDinners();
	}, []);

	return (
		<div className="row">
			<div className="col-12">
				<AppTitle text="Registro de Producto:" />
				<BreadCrumb items={[{ label: "Productos" }, { label: "Registro de Producto", active: true }]} />
			</div>
			<div className="card col-12">
				<div className="row card-body col-12">
					<div className="col-md-3">
						<AppInput
							label="Nombre del Producto"
							type="text"
							onChange={({ target }) => setName(target.value)}
							placeholder="Nombre Producto"
							errors={errorsForm.name}
						/>
					</div>
					<div className="col-md-3">
						<AppInput
							label="Precio del Producto"
							type="number"
							onChange={({ target }) => setPrice(target.value)}
							placeholder="Precio Producto"
							errors={errorsForm.price}
						/>
					</div>
					<div className="col-6">
						<AppSelect label="Comedor" items={dinnerList} onChange={(dinner) => setDinner(dinner ? dinner : {})} errors={errorsForm.dinner_id} />
					</div>
					<div className="col-12 text-center my-4">
						<button className="btn btn-primary" onClick={CreateProduct}>
							Registrar Producto
						</button>
					</div>
				</div>
			</div>
			<AppLoading visible={loading} />
		</div>
	);
}

export default ProductCreateScreen;
